export const CLASS_COLOR_PALETTE = 'color-palette';
